import Banner from '@/components/Banner/Banner';
import Footer from '@/components/Footer/Footer';
import Navbar from '@/components/Navbar/Navbar';
import { AppContextProvider } from '@/contexts/AppContextProvider';
import { Outlet } from '@tanstack/react-router';
import type { FC } from 'react';

const Layout: FC = () => {
  return (
    <AppContextProvider>
      <div className="min-h-screen flex flex-col">
        <Banner />
        <Navbar />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
      </div>
    </AppContextProvider>
  );
};

export default Layout;
